module.exports = __webpack_public_path__ + "img/decore-left.2d9d23e0.png";